import { UploadSelfie as DLUploadSelfie, GetAllMetadataSelfies as DLGetAllMetadataSelfies, GetAllSelfies as DLGetAllSelfies, GetSelfieById as DLGetSelfieById, SelectSelfie as DLSelectSelfie, DeselectSelfie as DLDeselectSelfie, DeleteSelfie as DLDeleteSelfie, GetSelfieSelected as DLGetSelfieSelected, ResetDinamyc as DLResetDinamyc, GetSelfiesPage as DLGetSelfiesPage, SendSelfiesFanIAToScreen as DLSendSelfiesFanIAToScreen, DeselectSelfieFanIA as DLDeselectSelfieFanIA, SendSelfiesFanMosaicToScreen as DLSendSelfiesFanMosaicToScreen, DeselectSelfieFanMosaic as DLDeselectSelfieFanMosaic, SendOverlayConfig as DLSendOverlayConfig, GetOverlaySettings as DLGetOverlaySettings, SaveOverlaySettings as DLSaveOverlaySettings, SendQRToOverlay as DLSendQRToOverlay, SendMessagesQRToOverlay as DLSendMessagesQRToOverlay, UploadStaffSelfieImage as DLUploadStaffSelfieImage, ExportLiveReport as DLExportLiveReport, SendLiveQRToOverlay as DLSendLiveQRToOverlay } from './../DL/SelfieFan'


// /**
//  * Sube una selfie a la API usando la DL.
//  * @param {{
//  *   blob: Blob,
//  *   filename: string,
//  *   endpointUrl: string,
//  *   token?: string | null,
//  *   mode?: "multipart" | "binary",
//  *   extraFields?: Record<string, string | number | boolean>
//  * }} args
//  * @returns {Promise<any>} JSON de la API
//  */
const UploadSelfie = async (selfieFanData) => { //args
    try {
        // const {
        //     blob,
        //     filename = "",
        //     token = null,
        //     mode = "binary",
        //     extraFields = {},
        // } = args || {}

        if (!(selfieFanData.blob instanceof Blob)) {
            return { success: false, message: 'Blob de imagen inválido.' }
            //throw new Error("Blob de imagen inválido.")
        }
        
        // Reglas de negocio simples (ejemplos):
        // - Tamaño máximo 5MB
        const MAX_BYTES = 5 * 1024 * 1024;
        if (selfieFanData.blob.size > MAX_BYTES) {
            return { success: false, message: 'La imagen es muy grande. Reduce la resolución.' }
            //throw new Error("La imagen es muy grande. Reduce la resolución.")
        }
        
        // - Solo JPEG/PNG
        const mime = selfieFanData.blob.type || "application/octet-stream"
        if (!/^image\/(jpeg|png)$/i.test(mime)) {
            return { success: false, message: 'Formato de imagen no soportado. Usa JPEG o PNG.' }
            //throw new Error("Formato de imagen no soportado. Usa JPEG o PNG.")
        }
        
        const selfieFanDataToSend = {
            blob: selfieFanData.blob,
            mode: selfieFanData.mode,
            caption: selfieFanData.caption,
            source: selfieFanData.source,
            fullName: selfieFanData.fullName,
            email: selfieFanData.email,
            phone: selfieFanData.phone,
            acceptedTerms: selfieFanData.acceptedTerms
        }

        // const response = await DLUploadSelfie({
        //     selfieFanData.blob,
        //     as: mode,
        //     extraFields
        // })

        const response = await DLUploadSelfie(selfieFanDataToSend)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: '' }
        }
    } catch (error) {

    }
}

/**
 * Sube N imágenes en modo binario (una petición por archivo).
 * Útil para el formulario Admin (source = "selfie_ia").
 */
const UploadMultipleImages = async ({files = [], caption = "", source = "selfie_ia" }) => {
    try {
        const results = []
        
        for (const f of files) {    
            const r = await UploadSelfie({ blob: f, caption, source })
            results.push({ name: f.name, ...r })
        }
        
        // Decide tu política: exito si todas OK, o con que una OK, etc.
        const allOk = results.every((r) => r.success)
        
        return { success: allOk, data: results }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar subir la(s) foto(s). Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const GetAllMetedataSelfies = async () => {
    try {
        const response = await DLGetAllMetadataSelfies()
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar obtener el listado de fotos. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const GetAllSelfies = async () => {
    try {
        const response = await DLGetAllSelfies()
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar obtener el listado de fotos. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const GetSelfieById = async (id) => {
    try {
        const response = await DLGetSelfieById(id)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar obtener la foto deseada. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const SelectSelfie = async (selfie) => {
    try {
        const response = await DLSelectSelfie(selfie.id)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar seleccionar la foto deseada. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const DeselectSelfie = async () => {
    try {
        const response = await DLDeselectSelfie()
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar deseleccionar la foto deseada. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const DeleteSelfie = async (selfie) => {
    try {
        const response = await DLDeleteSelfie(selfie.id)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar eliminar la foto deseada. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const GetSelfieSelected = async () => {
    try {
        const response = await DLGetSelfieSelected()
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar obtener la foto deseada. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}

const ResetDinamyc = async () => {
    try {
        const response = await DLResetDinamyc()
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar resetear la dinámica. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}










/**
 * Zona horaria de Ciudad de México (sin DST desde 2023; el navegador se encarga).
 */
const MX_TIMEZONE = 'America/Mexico_City'

/**
 * Crea un Intl.DateTimeFormat para MX con o sin segundos.
 */
const MakeMxFormatter = (includeSeconds = true) => {
    return new Intl.DateTimeFormat('es-MX', {
        timeZone: MX_TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: includeSeconds ? '2-digit' : undefined,
        hour12: false, // 24h
    })
}

/**
 * Convierte el input a Date. Acepta:
 *  - string ISO (p.ej. "2025-09-15T00:42:21.1844095Z")
 *  - Date
 *  - number (epoch ms)
 */
const ToDateOrThrow = (value) => {
    const d = value instanceof Date ? value : new Date(value)
    if (Number.isNaN(d.getTime())) {
        throw new Error('Fecha inválida')
    }
    return d
}

/**
 * Formatea partes usando formatToParts para asegurar dd/MM/yyyy HH:mm(:ss).
 */
const FormatParts = (date, includeSeconds) => {
    const parts = MakeMxFormatter(includeSeconds).formatToParts(date)
    // Mapeamos por tipo: { day, month, year, hour, minute, second }
    const map = Object.create(null)
    for (const p of parts) map[p.type] = p.value

    const dd = map.day ?? '--'
    const MM = map.month ?? '--'
    const yyyy = map.year ?? '----'
    const HH = map.hour ?? '--'
    const mm = map.minute ?? '--'
    const ss = includeSeconds ? (map.second ?? '--') : null

    return includeSeconds
        ? `${dd}/${MM}/${yyyy} ${HH}:${mm}:${ss} hrs.`
        : `${dd}/${MM}/${yyyy} ${HH}:${mm} hrs.`
}

/**
 * Función pura (utilidad): devuelve el string formateado.
 * @param {string|Date|number} utcValue - Fecha/hora en UTC (ISO con 'Z' recomendado).
 * @param {{ withSeconds?: boolean }} [opts]
 * @returns {string} "dd/MM/yyyy HH:mm:ss hrs."
 *
 * Ejemplo:
 *   formatUtcToMexico('2025-09-15T00:42:21.1844095Z')
 *   => "14/09/2025 19:42:21 hrs." (depende del huso y reglas vigentes)
 */
const FormatUtcToMexico = (utcValue, opts = {}) => {
    const { withSeconds = true } = opts
    const date = ToDateOrThrow(utcValue)
    // OJO: NO convertimos el Date manualmente Intl ya aplica la zona MX al formatear.
    return FormatParts(date, withSeconds)
}

/**
 * Versión estilo BL (siguiendo el patrón { success, data | message } que usas en DL).
 * Útil si quieres mantener uniformidad en tus “capas”.
 *
 * @param {string|Date|number} utcValue
 * @param {{ withSeconds?: boolean }} [opts]
 * @returns {{ success: true, data: string } | { success: false, message: string }}
 */
const FormatDateToMexico = (utcValue, opts = {}) => {
    try {
        const formattedDate = FormatUtcToMexico(utcValue, opts)
        return formattedDate
        //return { success: true, data }
    } catch {
        return null
        //return { success: false, message: 'No se pudo formatear la fecha/hora. Verifica el valor recibido.' }
    }
}

// /**
//  * BL: Regla de negocio para obtener una página ligera de selfies.
//  * - Valida y normaliza parámetros.
//  * - Devuelve estructura consistente para la UI.
//  *
//  * @param {Object} args
//  * @param {"selfie_fan"|"selfie_ia"|null} args.source
//  * @param {number} args.limit
//  * @param {string|null} args.cursor
//  * @returns {Promise<{success:boolean, data?: { items: Array, nextCursor: string|null }, message?: string}>}
//  */
// const GetSelfiesPage = async ({ source = null, limit = 30, cursor = null } = {}) => {
//     // Normalizaciones defensivas
//     const allowedSources = new Set(["selfie_fan", "selfie_ia"])
//     const normalizedSource = source && allowedSources.has(source) ? source : null
//     const pageSize = Math.min(Math.max(Number(limit) || 30, 1), 100)
//     const normalizedCursor = cursor || null

//     const resp = await DLGetSelfiesPage({source: normalizedSource, limit: pageSize, cursor: normalizedCursor})

//     if (!resp.success) return resp

//     // Estructura de salida uniforme (y orden defensivo por fecha desc si backend no lo garantiza)
//     const items = Array.isArray(resp.data?.items) ? resp.data.items : []
//     const sorted = items.sort((a, b) => new Date(b.createdAtUtc) - new Date(a.createdAtUtc))

//     // Aseguramos campos mínimos para la UI
//     const safeItems = sorted.map(it => ({
//         id: it.id,
//         source: it.source || "selfie_fan",
//         caption: it.caption || "",
//         contentType: it.contentType || "image/jpeg",
//         createdAtUtc: it.createdAtUtc,
//         isSelected: !!it.isSelected,
//         thumbUrl: it.thumbUrl,      // miniatura para grid
//         contentUrl: it.contentUrl,  // acceso binario completo (si lo necesitas en modal)
//     }))

//     return {
//         success: true,
//         data: { items: safeItems, nextCursor: resp.data?.nextCursor ?? null },
//     }
// }

/**
 * BL: Regla de negocio para obtener una página ligera de selfies.
 * - Valida y normaliza parámetros.
 * - Devuelve estructura consistente para la UI, incluyendo metadatos de estado.
 *
 * @param {Object} args
 * @param {"selfie_fan"|"selfie_ia"|null} args.source
 * @param {number} args.limit
 * @param {string|null} args.cursor
 * @returns {Promise<{success:boolean, data?: { items: Array, nextCursor: string|null }, message?: string}>}
 */
const GetSelfiesPage = async ({ source = null, limit = 30, cursor = null } = {}) => {
    // Normalizaciones defensivas
    const allowedSources = new Set(["selfie_fan", "selfie_ia", "selfie_staff", "selfie_live"])
    const normalizedSource = source && allowedSources.has(source) ? source : null
    const pageSize = Math.min(Math.max(Number(limit) || 30, 1), 100)
    const normalizedCursor = cursor || null

    // Llamada al Data Layer (Backend)
    const resp = await DLGetSelfiesPage({source: normalizedSource, limit: pageSize, cursor: normalizedCursor})

    if (!resp.success) return resp

    const items = Array.isArray(resp.data?.items) ? resp.data.items : []

    // NOTA: Eliminamos el sort por fecha aquí. 
    // El Backend ya devuelve los datos ordenados por Índice (o el criterio de la BD).
    // Reordenar aquí podría romper la consistencia visual de la paginación.
    
    // Aseguramos que pasen TODAS las propiedades nuevas a la UI
    const safeItems = items.map(it => ({
        id: it.id,
        // --- PROPIEDAD CRÍTICA: El índice numérico real de la BD ---
        index: it.index, 
        
        source: it.source || "selfie_fan",
        caption: it.caption || "",
        contentType: it.contentType || "image/jpeg",
        createdAtUtc: it.createdAtUtc,
        
        // --- PROPIEDADES DE ESTADO ---
        isSelected: !!it.isSelected,
        isHidden: !!it.isHidden,
        wasShown: !!it.wasShown,
        rotation: it.rotation || 0,
        
        thumbUrl: it.thumbUrl,      
        contentUrl: it.contentUrl,  
        fullName: it.fullName || "",
        email: it.email || "",
        phone: it.phone || "",
        acceptedTerms: !!it.acceptedTerms
    }))

    return {
        success: true,
        data: { items: safeItems, nextCursor: resp.data?.nextCursor ?? null },
    }
}

const SendSelfiesFanIAToScreen = async (selfiesData) => {
    try {
        if (!selfiesData || selfiesData?.length === 0) {
            return { success: false, message: 'No ha sido posible enviar la(s) Selfie Fan IA a la pantalla. Inténtalo nuevamente o inténtalo más tarde' }
        }
        
        const response = await DLSendSelfiesFanIAToScreen(selfiesData)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'No ha sido posible enviar la(s) Selfie Fan IA a la pantalla. Inténtalo nuevamente o inténtalo más tarde' }
    }
}

const DeselectSelfieFanIA = async () => {
    try {
        const response = await DLDeselectSelfieFanIA()
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'No ha sido posible quitar la(s) Selfie Fan IA a la pantalla. Inténtalo nuevamente o inténtalo más tarde' }
    }
}

const SendSelfiesFanMosaicToScreen = async (selfiesData) => {
    try {
        if (!selfiesData || selfiesData?.length === 0) {
            return { success: false, message: 'No ha sido posible enviar la(s) Selfie Fan Mosaic a la pantalla. Inténtalo nuevamente o inténtalo más tarde' }
        }
        
        const response = await DLSendSelfiesFanMosaicToScreen(selfiesData)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'No ha sido posible enviar la(s) Selfie Fan Mosaic a la pantalla. Inténtalo nuevamente o inténtalo más tarde' }
    }
}

const DeselectSelfieFanMosaic = async () => {
    try {
        const response = await DLDeselectSelfieFanMosaic()
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'No ha sido posible quitar la(s) Selfie Fan Mosaic a la pantalla. Inténtalo nuevamente o inténtalo más tarde' }
    }
}

const UpdateOverlayPositionAndScale = async (offsetX, offsetY, scale) => {
    try {
        const response = await DLSendOverlayConfig(offsetX, offsetY, scale);
        return response;
    } catch (error) {
        return { success: false, message: 'Error en BL al actualizar Overlay.' };
    }
};



// const SendQRToOverlay = async () => {
//     try {
//         const response = await DLSendQRToOverlay()
        
//         if (response.success) {
//             return { success: true, data: response.data }
//         } else {
//             return { success: false, message: response.message }
//         }
//     } catch (error) {
//         return { success: false, message: 'No ha sido posible enviar la señal para mostrar el QR en pantalla. Inténtalo nuevamente o inténtalo más tarde' }
//     }
// }

/**
 * ============================================================================
 * NUEVAS FUNCIONES: OVERLAY Y CÓDIGO QR
 * ============================================================================
 */

/**
 * Obtiene la configuración guardada del Overlay.
 */
const GetOverlaySettings = async () => {
    try {
        const response = await DLGetOverlaySettings();
        return response;
    } catch (error) {
        return { success: false, message: "Error inesperado al obtener configuración." };
    }
};

/**
 * Guarda la configuración del Overlay.
 * @param {number} x - Posición en el eje X
 * @param {number} y - Posición en el eje Y
 * @param {number} scale - Escala de la imagen
 */
const SaveOverlaySettings = async (x, y, scale) => {
    try {
        // Estructuramos el payload que espera el DTO en C#
        const payload = {
            x: typeof x === 'number' ? x : 0,
            y: typeof y === 'number' ? y : 0,
            scale: typeof scale === 'number' ? scale : 1.0
        };

        const response = await DLSaveOverlaySettings(payload);
        return response;
    } catch (error) {
        return { success: false, message: "Error inesperado al guardar configuración." };
    }
};

/**
 * Manda el comando para mostrar el código QR en la pantalla grande.
 */
const SendQRToOverlay = async () => {
    try {
        const response = await DLSendQRToOverlay();
        return response;
    } catch (error) {
        return { success: false, message: "Error inesperado al proyectar QR." };
    }
};

/**
 * Manda el comando para mostrar el código QR de mensajes en la pantalla grande.
 */
const SendMessagesQRToOverlay = async () => {
    try {
        const response = await DLSendMessagesQRToOverlay();
        return response;
    } catch (error) {
        return { success: false, message: "Error inesperado al proyectar QR." };
    }
};

/**
 * Manda el comando para mostrar el código QR de Live Barrio 9 en la pantalla grande.
 */
const SendLiveQRToOverlay = async () => {
    try {
        const response = await DLSendLiveQRToOverlay();
        return response;
    } catch (error) {
        return { success: false, message: "Error inesperado al proyectar QR Live." };
    }
};

/**
 * Valida las reglas de negocio antes de subir una foto del Staff.
 * * @param {Object} staffImagePayload - Objeto con los datos capturados en la UI.
 * @param {Blob} staffImagePayload.blob - El archivo de imagen.
 * @param {string} [staffImagePayload.caption=""] - Mensaje de apoyo (opcional).
 * @returns {Promise<Object>} Resultado de la operación { success, data/message }.
 */
const UploadStaffSelfie = async (staffImagePayload) => {
    try {
        // 1. Validar que realmente sea un objeto Blob/File
        if (!(staffImagePayload.blob instanceof Blob)) {
            return { success: false, message: 'El archivo generado no es una imagen válida.' };
        }
        
        // 2. Validar peso máximo (Ejemplo: 5MB límite para agilizar la subida con redes móviles 4G/5G en estadio)
        const MAXIMUM_ALLOWED_BYTES = 5 * 1024 * 1024;
        if (staffImagePayload.blob.size > MAXIMUM_ALLOWED_BYTES) {
            return { success: false, message: 'La imagen es muy pesada. El límite es de 5MB.' };
        }
        
        // 3. Validar MimeType (Solo Jpegs y Pngs)
        const imageMimeType = staffImagePayload.blob.type || "application/octet-stream";
        if (!/^image\/(jpeg|png)$/i.test(imageMimeType)) {
            return { success: false, message: 'Formato no soportado. Por favor usa JPG o PNG.' };
        }
        
        // 4. Mapear datos para la capa DL
        const dataForDataLayer = {
            imageBlob: staffImagePayload.blob,
            imageCaption: staffImagePayload.caption || ""
        };

        // 5. Ejecutar la subida
        const uploadResponse = await DLUploadStaffSelfieImage(dataForDataLayer);
        
        return uploadResponse;

    } catch (unexpectedError) {
        console.error("UploadStaffSelfieBL -> Error inesperado:", unexpectedError);
        return { success: false, message: 'Error interno al procesar la imagen del Staff.' };
    }
};

const ExportLiveReport = async () => {
    try {
        const response = await DLExportLiveReport();
        return response;
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar exportar el reporte.' };
    }
};

export { UploadSelfie, UploadMultipleImages, GetAllMetedataSelfies, GetAllSelfies, GetSelfieById, SelectSelfie, DeselectSelfie, DeleteSelfie, GetSelfieSelected, ResetDinamyc, FormatDateToMexico, GetSelfiesPage, SendSelfiesFanIAToScreen, DeselectSelfieFanIA, SendSelfiesFanMosaicToScreen, DeselectSelfieFanMosaic, UpdateOverlayPositionAndScale, GetOverlaySettings, SaveOverlaySettings, SendQRToOverlay, SendMessagesQRToOverlay, UploadStaffSelfie, ExportLiveReport, SendLiveQRToOverlay };